module.exports = __webpack_public_path__ + "static/media/bg-congratu-head.99875f25.png";